import { Link } from "expo-router";
import { Button } from "@ptsd/uikit";
import { useTranslation } from "react-i18next";
import { Text, View } from "tamagui";

import type { TSpheres } from "@edenlabllc/ptsd-validators";

import { api } from "~/utils/api";

const HMT_DOMAIN = "hmt";

export const MetricsSidebar: React.FC<{
  slug: TSpheres;
}> = ({ slug }) => {
  const { t } = useTranslation("metrics");

  const [data] = api.dashboard.getGroupedSpheres.useSuspenseQuery();

  return (
    <View
      data-id="metrics-sidebar-container"
      gap={"$3"}
      maxWidth={220}
      width={"100%"}
      borderRightWidth={"$0.2"}
      borderRightColor={"black"}
      paddingTop={"$8"}
      flex={1}
      height={"100%"}
      paddingRight={"$2.5"}
      $short={{
        gap: "$2",
        paddingTop: "$4",
      }}
    >
      <View gap={"$0.5"}>
        <Text
          data-id="metrics-sidebar-home"
          paddingLeft={"$2"}
          fontFamily={"$subtitle"}
          fontWeight={"$4"}
          fontSize={"$2"}
          lineHeight={"$2"}
          color={"$gray-secondary-400"}
        >
          {t("side-bar.main.subtitle")}
        </Text>
        <View gap={"$0.5"}>
          <Link
            data-id="metrics-sidebar-link-hmt"
            href={`/metrics/${HMT_DOMAIN}`}
            asChild
          >
            <Button
              paddingHorizontal={"$2"}
              maxWidth={200}
              rounded="lg"
              size="md"
              variant={slug === HMT_DOMAIN ? "primary" : "transparent"}
              height={"$5.3"}
              justifyContent="flex-start"
            >
              <Text
                fontFamily={"$subtitle"}
                fontSize={"$2"}
                lineHeight={"$2"}
                fontWeight={slug === HMT_DOMAIN ? "$6" : "$4"}
                color={slug === HMT_DOMAIN ? "white" : "$gray-primary-900"}
              >
                {t("side-bar.main.sphere-name")}
              </Text>
            </Button>
          </Link>
        </View>
      </View>

      {data.data?.map((item) => (
        <View key={item.sphere} gap={"$0.5"}>
          <Text
            data-id={`metrics-sidebar-${item.sphere}`}
            paddingLeft={"$2"}
            fontFamily={"$subtitle"}
            fontWeight={"$4"}
            fontSize={"$2"}
            lineHeight={"$2"}
            color={"$gray-secondary-400"}
          >
            {item.name}
          </Text>
          <View gap={"$0.5"}>
            {item.domains.map((child) => (
              <Link
                key={child.title}
                data-id={`metrics-sidebar-link-${child.domain}`}
                href={`/metrics/${child.domain}`}
                asChild
              >
                <Button
                  paddingHorizontal={"$2"}
                  maxWidth={200}
                  rounded="lg"
                  size="md"
                  variant={slug === child.domain ? "primary" : "transparent"}
                  height={"$5.3"}
                  justifyContent="flex-start"
                >
                  <Text
                    fontFamily={"$subtitle"}
                    fontWeight={slug === child.domain ? "$6" : "$4"}
                    fontSize={"$2"}
                    lineHeight={"$2"}
                    color={
                      slug === child.domain ? "white" : "$gray-primary-900"
                    }
                  >
                    {child.title}
                  </Text>
                </Button>
              </Link>
            ))}
          </View>
        </View>
      ))}
    </View>
  );
};
